import styles from './Divider.module.scss'

const Divider = () => <div className={styles.divider} />

export default Divider
